import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var TableSettingsDialogFooter = function TableSettingsDialogFooter(props) {
  var hasChanged = props.hasChanged,
    isResetAll = props.isResetAll,
    immediateChange = props.immediateChange,
    resetButtonText = props.resetButtonText,
    onHide = props.onHide,
    closeButtonText = props.closeButtonText,
    cancelButtonText = props.cancelButtonText,
    applyButtonText = props.applyButtonText,
    onResetColumnChanges = props.onResetColumnChanges,
    onConfirmResetColumnChanges = props.onConfirmResetColumnChanges,
    onCancelResetColumnChanges = props.onCancelResetColumnChanges,
    onDiscardChanges = props.onDiscardChanges,
    onApplyChanges = props.onApplyChanges;
  var restButtonClassNames = classNames('btn', 'btn-link', !hasChanged && 'disabled');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "pull-left"
  }, !isResetAll && /*#__PURE__*/React.createElement("div", {
    className: restButtonClassNames,
    onClick: onResetColumnChanges
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-revert text-size-xs margin-right-10"
  }), resetButtonText), isResetAll && /*#__PURE__*/React.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn btn-icon-only btn-default margin-right-5 btn-outline",
    onClick: onCancelResetColumnChanges
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-remove"
  })), /*#__PURE__*/React.createElement("div", {
    className: "btn btn-primary btn-icon-only",
    onClick: onConfirmResetColumnChanges
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-ok"
  })))), immediateChange ? /*#__PURE__*/React.createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn btn-default",
    onClick: onHide
  }, closeButtonText)) : /*#__PURE__*/React.createElement("div", {
    className: "pull-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn btn-default",
    onClick: onDiscardChanges
  }, cancelButtonText), /*#__PURE__*/React.createElement("div", {
    className: "btn btn-primary",
    onClick: onApplyChanges
  }, applyButtonText)));
};
TableSettingsDialogFooter.defaultProps = {
  hasChanged: false,
  isResetAll: false,
  immediateChange: false,
  resetButtonText: '',
  closeButtonText: '',
  cancelButtonText: '',
  applyButtonText: '',
  onHide: function onHide() {
    return undefined;
  },
  onResetColumnChanges: function onResetColumnChanges() {
    return undefined;
  },
  onDiscardChanges: function onDiscardChanges() {
    return undefined;
  },
  onApplyChanges: function onApplyChanges() {
    return undefined;
  }
};
TableSettingsDialogFooter.propTypes = {
  hasChanged: PropTypes.bool,
  isResetAll: PropTypes.bool,
  immediateChange: PropTypes.bool,
  resetButtonText: PropTypes.node,
  closeButtonText: PropTypes.node,
  cancelButtonText: PropTypes.node,
  applyButtonText: PropTypes.node,
  onHide: PropTypes.func,
  onResetColumnChanges: PropTypes.func,
  onDiscardChanges: PropTypes.func,
  onApplyChanges: PropTypes.func,
  onConfirmResetColumnChanges: PropTypes.func,
  onCancelResetColumnChanges: PropTypes.func
};